import { queryBuilder } from '@inpart-io/devtools-iap';
import { GET_BY_ID, RETRIEVE_BY_QUERY, SESSION_MODULE } from '@inpart-io/devtools-vue';
import { DataType, DefaultCategoryValues, type IPrivateLeadBoard } from '@inpart-io/padme-iap';
import { privateLeadBoardProperties } from '@inpart-io/padme-iap';
import { type LocationQueryRaw, type RouteLocation, type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';
import { routerHelper } from '@/services/router-helper';
import { store } from '@/store';
import { APPLICATION_MODULE } from '@/store/application-module';
import { SET_RECENT_AGREEMENT_BOARD_ID } from '@/store/application-module/actions';
import { GET_RECENT_AGREEMENT_BOARD_ID } from '@/store/application-module/getters';
import { PRIVATE_LEAD_BOARD_MODULE } from '@/store/private-lead-board-module';
import { GET_DEFAULT_BOARD } from '@/store/private-lead-board-module/getters';
import { GET_TENANT_USER_CURRENT_KEY } from '@/store/session-module/getters';

const AgreementHub = (): unknown => {
    return import(/* webpackPrefetch: true */ './agreement-hub-page.vue');
};

const queryForBoard = (board: IPrivateLeadBoard): LocationQueryRaw => {
    return Object.fromEntries(new URLSearchParams(board?.criteria).entries());
};

export const agreementHubMainRoute: RouteRecordRaw = {
    ...ROUTE_DATA.AGREEMENT_HUB_PAGE,
    components: {
        main: AgreementHub
    },
    beforeEnter: (to, from, next) => {
        const userKey = store.getters[`${SESSION_MODULE}/${GET_TENANT_USER_CURRENT_KEY}`];
        const boardId = store.getters[`${APPLICATION_MODULE}/${GET_RECENT_AGREEMENT_BOARD_ID}`](userKey);
        if (boardId !== undefined) {
            let board = store.getters[`${PRIVATE_LEAD_BOARD_MODULE}/${GET_BY_ID}`](boardId);
            if (board === undefined) {
                const idQuery = queryBuilder.build(queryBuilder.op.and(queryBuilder.cmp.isIn('dobjId', [boardId])));
                void store
                    .dispatch(`${PRIVATE_LEAD_BOARD_MODULE}/${RETRIEVE_BY_QUERY}`, {
                        query: idQuery,
                        properties: privateLeadBoardProperties.DEFAULT
                    })
                    .then(() => {
                        board = store.getters[`${PRIVATE_LEAD_BOARD_MODULE}/${GET_BY_ID}`](boardId);
                        if (board !== undefined) {
                            next({
                                name: agreementHubBoardRoute.name,
                                params: { id: boardId },
                                query: queryForBoard(board)
                            });
                        } else {
                            try {
                                const allBoard = store.getters[`${PRIVATE_LEAD_BOARD_MODULE}/${GET_DEFAULT_BOARD}`](
                                    DefaultCategoryValues.ALL,
                                    DataType.Agreement
                                );
                                next({ name: agreementHubBoardRoute.name, params: { id: allBoard.dobjId }, query: queryForBoard(allBoard) });
                            } catch (error) {
                                console.error('The tenant may be missing agreement default views', error);
                            }
                        }
                    });
            } else {
                next({
                    name: agreementHubBoardRoute.name,
                    params: { id: boardId },
                    query: queryForBoard(board)
                });
            }
        } else {
            try {
                const allBoard = store.getters[`${PRIVATE_LEAD_BOARD_MODULE}/${GET_DEFAULT_BOARD}`](DefaultCategoryValues.ALL, DataType.Agreement);
                next({ name: agreementHubBoardRoute.name, params: { id: allBoard.dobjId }, query: queryForBoard(allBoard) });
            } catch (error) {
                console.error('The tenant may be missing agreement default views', error);
            }
        }
    }
};

export const agreementHubBoardRoute: RouteRecordRaw = {
    ...ROUTE_DATA.AGREEMENT_HUB_PAGE_BOARD,
    components: {
        main: AgreementHub
    },
    props: {
        main(route: RouteLocation): { boardId?: number } {
            const boardId = routerHelper.parseParamToInt(route.params.id as string);
            void store.dispatch(`${APPLICATION_MODULE}/${SET_RECENT_AGREEMENT_BOARD_ID}`, {
                boardId
            });
            return { boardId };
        }
    }
};
